<template>
  <section>
    <div class="container box mt-5">
      <div class="content mb-6 has-text-centered">
        <h1>Gestión de participantes proceso {{ year }}</h1>
      </div>

      <div class="columns">
        <div class="column">
          <div class="title is-5">
            Filtros de Búsqueda
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(checkFilter)">
          <div class="columns mb-0">
            <ValidationProvider
              v-if="!showFromUnit"
              class="column"
              name="Unidad"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Unidad "
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <multiselect
                  v-model="filter.unit_id"
                  :options="units.map((type) => type.id)"
                  :custom-label="(opt) => units.find((x) => x.id === opt).name"
                  placeholder="Seleccione una Unidad"
                  selectLabel="Presione para seleccionar"
                  selectedLabel="Seleccionado"
                  deselectLabel="Presione para deseleccionar"
                  allow-empty
                >
                  <template v-slot:noOptions> No existen datos </template>
                  <span slot="noResult"> No se encontraron elementos. </span>
                </multiselect>
              </b-field>
            </ValidationProvider>

            <div :class="showFromUnit ? 'column' : 'column is-3'">
              <b-field label="RUN">
                <ValidationProvider
                  name="RUT"
                  rules="integer|min:7|max:8"
                  v-slot="{ errors }"
                >
                  <b-input v-model="filter.rut" placeholder="Ej: 12345678" />
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <div :class="showFromUnit ? 'column' : 'column is-2'">
              <b-field label="DV">
                <ValidationProvider
                  name="DV"
                  rules="min:1|max:1"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="filter.dv"
                    placeholder="Ej: 1 o K"
                    maxlength="1"
                  />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <ValidationProvider
              class="column"
              name="Primer Apellido"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Primer Apellido"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input v-model="filter.last_name" placeholder="Ej: Solis" />
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              class="column"
              name="Segundo Apellido"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Segundo Apellido"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.second_surname"
                  placeholder="Ej: Dominguez"
                />
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              class="column"
              name="Nombres"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Nombre"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.name"
                  placeholder="Ej: Felipe Cristian"
                />
              </b-field>
            </ValidationProvider>
          </div>

          <div class="columns">
            <div class="column has-text-right">
              <b-button
                v-if="haveFilters"
                label="Limpiar Filtros"
                icon-left="broom"
                type="is-warning is-light"
                @click="cleanFilters()"
              />
              <b-button
                label="Aplicar Filtros"
                icon-left="search"
                type="is-blue-color"
                @click="checkFilter()"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>

      <br />
      <br />

      <div v-if="isActiveFilter" class="columns">
        <div class="column">
          <div class="title is-5">
            Listado del cuerpo académico
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <b-table
        :data="academicPerformances"
        striped
        paginated
        per-page="10"
        :pagination-simple="false"
        pagination-position="bottom"
        aria-next-label="Siguiente"
        aria-previous-label="Anterior"
        aria-page-label="Página"
        aria-current-label="Página actual"
        default-sort-direction="asc"
        default-sort="academic_name"
        sort-icon="arrow-up"
        sort-icon-size="is-small"
      >
        <b-table-column
          label="Nombre"
          field="academic_name"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.academic_name }}
        </b-table-column>

        <b-table-column
          label="Rut"
          field="academic_rut"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.academic_rut }}
        </b-table-column>

        <b-table-column
          :visible="!showFromUnit"
          label="Unidad"
          field="academic_unit_name"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.academic_unit_name }}
        </b-table-column>

        <b-table-column
          label="Función"
          field="function"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.function ? props.row.function : "Académica/o" }}
        </b-table-column>

        <b-table-column
          label="¿Participa?"
          field="can_participate"
          width="100"
          sortable
          v-slot="props"
        >
          <b-switch
            v-model="props.row.can_participate"
            @input="updateCanParticipate(props.row)"
          >
            {{ props.row.can_participate ? "Sí" : "No" }}
          </b-switch>
        </b-table-column>
        <template slot="empty" slot-scope="props">
          <div class="columns is-centered">
            <div class="column is-6 is-centered has-text-centered">
              <b-message type="is-warning">
                No se han encontrado registros de Desempeños.
              </b-message>
            </div>
          </div>
        </template>
      </b-table>

      <b-loading v-model="isLoading" />
    </div>
  </section>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "ManagePerformanceParticipants",

  props: {
    year: {
      type: Number,
      required: true,
    },
    showFromUnit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      //Auxiliar variables
      isLoading: false,
      isModalNewEditProcessActive: false,
      selectedProcessId: null,
      isProcessActive: false,
      updateProcess: false,
      proceedProcess: false,
      isActiveFilter: false,
      haveFilters: false,

      //Data for table
      data: [],

      //Data from API
      process: [],
      units: [],
      phases_types: [],
      academicPerformances: [],
      lastPhaseProcessName: null,

      //Filters
      filter: {
        unit_id: null,
        cost_center: null,
        run: null,
        dv: null,
        last_name: null,
        second_surname: null,
        name: null,
      },
      filterBy: "ACEPTADA",
    };
  },
  async created() {
    await this.setProcess();
    if (!this.showFromUnit) await this.getUnits();
    await this.getAcademicPerformances();
  },
  methods: {
    async getProcess() {
      this.isLoading = true;
      await axios
        .get("/performance_phases/process/" + this.year + ".json")
        .then((response) => {
          this.process = response.data;
          this.process.forEach((element) => {
            element.start_date = moment(element.start_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
            ]);
            element.end_date = moment(element.end_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
            ]);
          });
          this.lastPhaseProcessName =
            this.process[this.process.length - 1].phase_d_type.alt_name;
          this.isProcessActive = this.process.length < 4;
          this.selectedProcessId = this.process.slice(-1)[0].id;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getTypePhases() {
      this.isLoading = true;
      await axios
        .get("/phase_d_types.json")
        .then((response) => {
          this.phases_types = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.$emit("close");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async setProcess() {
      this.data = [];
      await this.getProcess();
      await this.getTypePhases();

      this.phases_types.forEach((element) => {
        let phase = this.process.find((x) => x.phase_d_type.id === element.id);

        element.start_date = phase ? phase.start_date : null;
        element.end_date = phase ? phase.end_date : null;
        element.is_started = phase ? true : false;

        this.data.push(element);
      });
    },

    async getUnits() {
      this.isLoading = true;
      await axios
        .get("/units/get-departments-of-engineering-faculty.json")
        .then((response) => {
          this.units = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async checkFilter() {
      let valid = await this.$refs.observer.validate();
      if (!valid) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Algunos campos presentan errores.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      this.haveFilters = !Object.values(this.filter).every(
        (value) => value === null
      );

      await this.getAcademicPerformances();
    },

    async cleanFilters() {
      this.filter = {
        unit_id: null,
        cost_center: null,
        run: null,
        dv: null,
        last_name: null,
        second_surname: null,
        name: null,
      };
      this.haveFilters = false;
      await this.getAcademicPerformances();
    },

    async getAcademicPerformances() {
      this.isLoading = true;
      if (this.showFromUnit) this.filter.unit_id = this.unit.id;
      await axios
        .get("/performances/get-by-academic-filters.json", {
          params: {
            process_year: this.year,
            ...this.filter,
          },
        })
        .then((response) => {
          this.academicPerformances = response.data;
          this.isActiveFilter = true;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          if (this.showFromUnit) this.filter.unit_id = null;
          this.isLoading = false;
        });
    },
    updateCanParticipate(academic) {
      this.isLoading = true;
      axios
        .put(
          `/performances/update-participation/${academic.academic_id}.json`,
          {
            can_participate: academic.can_participate,
          }
        )
        .then((response) => {
          this.$buefy.dialog.alert({
            title: "Éxito",
            message: "Participación actualizada correctamente.",
            type: "is-success",
            hasIcon: true,
            icon: "check-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .catch((error) => {
          console.error("Error updating participation:", error);
          academic.can_participate = !academic.can_participate;
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar actualizar la participación. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
